<template lang="pug">
  b-modal#promoBannerModal(
    ref="promoBannerModal"
    :title="$t('ui.combine.edit_promotion_banner')"
    centered
    no-fade
    no-close-on-backdrop
    :busy="bannerModalLoading || pageLoading"
    @ok="onPromoBannerModalOk"
    @hidden="onPromoBannerModalHidden"
  )
    b-form(@submit.stop.prevent="onPromoBannerModalOk")
      b-form-group(:label="$t('ui.promotion_id')" disabled).mb-0
        b-form-input(size="sm" :value="bannerModalPromotionId" disabled)
      b-form-group(:label="$t('ui.banner_type')").mb-0
        b-form-select(
          size="sm"
          v-model="bannerModalViewType"
          :options="bannerModalViewOptions"
          :disabled="bannerModalLoading || pageLoading"
          @change="onBannerModalViewTypeChange"
        )
      b-form-group(:label="$t('ui.banner_id')").mb-0
        b-form-input(
          size="sm"
          type="text"
          v-model.trim="bannerModalBannerId"
          :disabled="bannerModalLoading || pageLoading"
          autocomplete="off"
        )
        .small.text-danger(v-if="bannerModalBannerIdError") {{ bannerModalBannerIdError }}
      b-button.mt-2(
        v-if="bannerModalLinked"
        type="button"
        variant="outline-danger"
        size="sm"
        :disabled="bannerModalLoading || pageLoading"
        @click="onPromoBannerModalUnlink"
      ) {{ $t("ui.combine.unlink_banner") }}
    div(slot="modal-cancel")
      SubmitButton(
        :loading="bannerModalLoading || pageLoading"
        icon="fa fa-ban"
        :text="$t('ui.cancel')"
        isModal=true
      )
    div(slot="modal-ok")
      SubmitButton(
        :loading="bannerModalLoading || pageLoading"
        icon="fa fa-save"
        :text="$t('ui.save')"
        isModal=true
      )
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";

export default {
  name: "EditPromoBanner",
  components: {
    SubmitButton
  },
  props: {
    pageLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      bannerModalPromotionId: "",
      bannerModalViewType: 1,
      bannerModalBannerId: "",
      bannerModalBannerIdError: "",
      bannerModalLoading: false,
      bannerModalRow: null
    };
  },
  computed: {
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
    bannerModalViewOptions() {
      return [
        { value: 1, text: this.$t("ui.slot_view") },
        { value: 2, text: this.$t("ui.non_slot_view") }
      ];
    },
    bannerModalLinked() {
      if (!this.bannerModalRow) return false;
      return this.promoBannerLinkedForView(this.bannerModalRow, Number(this.bannerModalViewType));
    }
  },
  methods: {
    open(item) {
      this.bannerModalRow = item;
      this.bannerModalPromotionId = item.promotion_id;
      this.bannerModalViewType = 1;
      this.bannerModalBannerIdError = "";
      this.syncBannerModalBannerIdFromRow();
      this.$refs.promoBannerModal.show();
    },
    syncBannerModalBannerIdFromRow() {
      if (!this.bannerModalRow) return;
      const v = Number(this.bannerModalViewType);
      const raw = v === 1 ? this.bannerModalRow.banner_id1 : this.bannerModalRow.banner_id2;
      this.bannerModalBannerId = this.promoBannerIdPresent(raw) ? String(raw).trim() : "";
    },
    onBannerModalViewTypeChange() {
      this.syncBannerModalBannerIdFromRow();
      this.bannerModalBannerIdError = "";
    },
    onPromoBannerModalHidden() {
      this.bannerModalRow = null;
      this.bannerModalPromotionId = "";
      this.bannerModalViewType = 1;
      this.bannerModalBannerId = "";
      this.bannerModalBannerIdError = "";
      this.bannerModalLoading = false;
    },
    hidePromoBannerModal() {
      if (this.$refs.promoBannerModal) {
        this.$refs.promoBannerModal.hide();
      }
    },
    onPromoBannerModalOk(evt) {
      evt.preventDefault();
      this.bannerModalBannerIdError = "";
      const id = (this.bannerModalBannerId || "").trim();
      if (!id) {
        this.bannerModalBannerIdError = this.$t("error.bannerIdRequired");
        return;
      }
      if (!/^\d+$/.test(id)) {
        this.bannerModalBannerIdError = this.$t("error.isInteger", { fname: this.$t("ui.banner_id") });
        return;
      }

      const url = config.promotionUpdateBannerUrl();
      const json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        promotion_id: this.bannerModalPromotionId,
        banner_id: id,
        view_type: Number(this.bannerModalViewType)
      };

      this.bannerModalLoading = true;
      this.$http.post(url, json).then(
        response => {
          this.bannerModalLoading = false;
          try {
            if (response) {
              let ok = false;
              if (typeof response.data.status == "string") {
                ok = response.data.status == "1";
              } else {
                ok = response.data.status == 1;
              }
              const status = response.data.statusdesc;
              if (ok) {
                this.hidePromoBannerModal();
                this.$emit("banner-updated");
                this.$helpers.showDialog(
                  this.$t("ui.combine.edit_promotion_banner"),
                  this.$t("message.success"),
                  "success"
                );
              } else {
                this.$helpers.handleFeedback(status);
                this.$emit("failed", "edit_promotion_banner", status);
              }
            }
          } catch (error) {
            this.bannerModalBannerIdError = this.$t("error." + errorTags.request.failed);
          }
        },
        () => {
          this.bannerModalLoading = false;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + errorTags.request.failed), "error");
        }
      );
    },
    onPromoBannerModalUnlink() {
      if (!this.bannerModalRow) return;
      this.confirmUnlinkPromoBanner(this.bannerModalRow, this.bannerModalViewType);
    },
    promoBannerIdPresent(val) {
      if (val == null || val === "") return false;
      if (typeof val === "string" && val.trim() === "") return false;
      return true;
    },
    promoBannerLinkedForView(item, viewType) {
      const id = viewType === 1 ? item.banner_id1 : item.banner_id2;
      return this.promoBannerIdPresent(id);
    },
    confirmUnlinkPromoBanner(item, viewType) {
      const viewLabel = viewType === 1 ? this.$t("ui.slot_view") : this.$t("ui.non_slot_view");
      this.$helpers
        .alert({
          title: this.$t("ui.alert"),
          text: this.$t("message.unlink_promotion_banner_confirm", {
            id: item.promotion_id,
            view: viewLabel
          }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.submitUnlinkPromoBanner(item, viewType);
          }
        });
    },
    submitUnlinkPromoBanner(item, viewType) {
      const url = config.promotionUnlinkBannerUrl();
      const json = {
        action_by: this.$store.getters.loginId,
        audit_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        promotion_id: item.promotion_id,
        view_type: Number(viewType)
      };

      this.bannerModalLoading = true;
      this.$http.post(url, json).then(
        response => {
          this.bannerModalLoading = false;
          try {
            if (response) {
              let success = false;
              if (typeof response.data.status == "string") {
                success = response.data.status == "1";
              } else {
                success = response.data.status == 1;
              }
              const status = response.data.statusdesc;
              if (success) {
                this.hidePromoBannerModal();
                this.$emit("banner-updated");
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(status)) {
                  this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + status), "error");
                }
                this.$emit("banner-updated");
              }
            }
          } catch (error) {
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + errorTags.request.failed), "error");
          }
        },
        () => {
          this.bannerModalLoading = false;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + errorTags.request.failed), "error");
        }
      );
    }
  }
};
</script>
